(function($) {
    'use strict';

    // Place any jQuery/helper plugins in here.
    function isValidEmail(email) {
        var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }

    $(function() {

        /**
         * Handle UI changes on different invoice type choices
         */
        $(document).on('change', "[name='invoice_type']", function() {
            var invoice_type = $('[name=invoice_type]:checked').val();

            var $parent = $(this).parent('form');

            // show/hide the fields
            $('.invoice-type-field').hide();
            $('.invoice-type-field.' + invoice_type).show();

            // empty the fields that are not related to the new invoice type

            switch (invoice_type) {
                case 'invoice_none':
                    // empty all fields
                    $parent.find('[name=invoice_names]').val('');
                    $parent.find('[name=invoice_egn]').val('');
                    $parent.find('[name=invoice_company]').val('');
                    $parent.find('[name=invoice_company_ein]').val('');
                    $parent.find('[name=invoice_company_vat]').val('');
                    $parent.find('[name=invoice_mol]').val('');
                    $parent.find('[name=invoice_address]').val('');
                    $parent.find('[name=invoice_city]').val('');
                    $parent.find('[name=invoice_postcode]').val('');
                    break;
                case 'invoice_personal':
                    // clear company fields
                    $parent.find('[name=invoice_company]').val('');
                    $parent.find('[name=invoice_company_ein]').val('');
                    $parent.find('[name=invoice_company_vat]').val('');
                    $parent.find('[name=invoice_mol]').val('');
                    break;
                case 'invoice_company':
                    // clear personal fields
                    $parent.find('[name=invoice_names]').val('');
                    $parent.find('[name=invoice_egn]').val('');
                    break;
            }
        });

        $("[name=invoice_type]:checked").trigger('change');

        /**
         * Handle order validation and processing
         */
        (function() {
            var $form = $('.order_form'),
                $form_wrapper = $form.parent('.form-wrapper'),
                url = $form.attr('action'),
                hasError = false,
                data = {},

                // csrf protection
                $tokenInputField = $form.find('#token_order'),
                postTokenName = $tokenInputField.attr('name'),
                postTokenValue = $tokenInputField.val(),

                // form fields
                $name = $form.find('[name=name]'),
                $names = $form.find('[name=names]'),
                $email = $form.find('[name=email]'),
                $phone = $form.find('[name=phone]'),

                $delivery_city = $form.find('[name=delivery_city]'),
                $delivery_postcode = $form.find('[name=delivery_postcode]'),
                $delivery_district = $form.find('[name=delivery_district]'),
                $delivery_street = $form.find('[name=delivery_street]'),
                $delivery_street_num = $form.find('[name=delivery_street_num]'),
                $delivery_address_details = $form.find('[name=delivery_address_details]'),

                $notes = $form.find('[name=notes]'),

                $invoice_type = $form.find('[name=invoice_type]:checked'),

                $invoice_company = $form.find('[name=invoice_company]'),
                $invoice_company_ein = $form.find('[name=invoice_company_ein]'),
                $invoice_company_vat = $form.find('[name=invoice_company_vat]'),
                $invoice_mol = $form.find('[name=invoice_mol]'),
                $invoice_names = $form.find('[name=invoice_names]'),
                $invoice_egn = $form.find('[name=invoice_egn]'),
                $invoice_address = $form.find('[name=invoice_address]'),
                $invoice_city = $form.find('[name=invoice_city]'),
                $invoice_postcode = $form.find('[name=invoice_postcode]'),

                $form_order = $form.find('[name=form_order]');


            $form.on('submit', function (event) {
                event.preventDefault();

                console.log('onSubmit');

                $form.find('input').prop('disabled', true);
                $form.find('.error').remove();
                $form.find('.field_error').removeClass('field_error');
                $form.find('button[type=submit]').addClass('loading');

                hasError = false;

                if ($name.val() == '') {
                    hasError = true;
                    $name.addClass('field_error');
                }

                if (!isValidEmail($email.val())) {
                    hasError = true;
                    $email.addClass('field_error');
                }

                if ($phone.val() == '') {
                    hasError = true;
                    $phone.addClass('field_error');
                }

                if (hasError) {
                    $form.find('input').prop('disabled', false);
                    $form.find('button[type=submit]').removeClass('loading');

                    $('html, body').animate({
                        scrollTop: $(".field_error").first().offset().top - 40
                    }, 1000);

                    return false;
                }

                data = {
                    name: $name.val() || '',
                    email: $email.val() || '',
                    phone: $phone.val() || '',

                    names_: $names.val() || '',
                    form_order: $form_order.val() || '',

                    delivery_city: $delivery_city.val() || '',
                    delivery_postcode: $delivery_postcode.val() || '',
                    delivery_district: $delivery_district.val() || '',
                    delivery_street: $delivery_street.val() || '',
                    delivery_street_num: $delivery_street_num.val() || '',
                    delivery_address_details: $delivery_address_details.val() || '',
                    notes: $notes.val() || '',

                    invoice_type: $form.find('[name=invoice_type]:checked').val() || 'invoice_company_ex',

                    invoice_company: $invoice_company.val() || '',
                    invoice_company_ein: $invoice_company_ein.val() || '',
                    invoice_company_vat: $invoice_company_vat.val() || '',
                    invoice_mol: $invoice_mol.val() || '',
                    invoice_names: $invoice_names.val() || '',
                    invoice_egn: $invoice_egn.val() || '',
                    invoice_address: $invoice_address.val() || '',
                    invoice_city: $invoice_city.val() || '',
                    invoice_postcode: $invoice_postcode.val() || ''
                };

                $.ajax({
                    type: "post",
                    beforeSend: function (request) {
                        request.setRequestHeader("X-" + postTokenName, postTokenValue);
                    },
                    url: url,
                    data: data,
                    dataType: 'json'
                })
                    .done(function(data, textStatus, jqXHR) {

                        if (data.error) {
                            // handle php validation error messages
                            $form.find('.error').remove();
                            $form.find('.field_error').removeClass('field_error');

                            $.each(data.errors, function(field, msg) {
                                var $field = $('#' + field);
                                $field.addClass('field_error');
                                $field.after("<span class='error'>" + msg + "</span>");
                            });

                        } else {
                            // success
                            console.info('success', data.message);

                            if (data.nextUrl) {
                                window.location.href = data.nextUrl;
                            }

                            if (data.message) {
                                $form_wrapper.slideUp(400, function() {
                                    $form_wrapper.html(data.message);
                                    $form_wrapper.slideDown(300);
                                });
                            }
                        }
                    })
                    .fail(function(jqXHR, textStatus, errorThrown) {
                        console.log('ajax failed', textStatus);
                        alert(textStatus);
                    })
                    .always(function(datajqXHR, textStatus, jqXHRerrorThrown) {
                        $form.find('input').prop('disabled', true);
                        $form.find('button[type=submit]').addClass('loading');
                    });
            });


        })();

    });

} (jQuery));